<app-confirm-deletion-dialog
        [bodyHtml]="dialogBody"
        [dialogCloseObject]="data.email"
        [errorToastMessage]="'User is NOT deleted!'"
        [deletionCallback]="getDeletionCallback" />
